import Base from './base'
import urls from 'config/urls'

class Sku extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.sku.find,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.sku.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.sku.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.sku.delete,
      data: opts
    })
  }

  findAttribute (opts) {
    return this.httpGet({
      url: urls.sku.findAttribute,
      data: opts
    })
  }

  createAttribute (opts) {
    return this.httpPost({
      url: urls.sku.createAttribute,
      data: opts
    })
  }

  updateAttribute (opts) {
    return this.httpPost({
      url: urls.sku.updateAttribute,
      data: opts
    })
  }

  deleteAttribute (opts) {
    return this.httpPost({
      url: urls.sku.deleteAttribute,
      data: opts
    })
  }
}

export default new Sku



// WEBPACK FOOTER //
// ./src/models/sku.js